import { IAffairAttachmentDeleteApi, IAffairDeleteApi, IAffairPub, IAffairRestoreApi, IAffariDirectGetApi, IAttachment, IAttachmentExtVideo, IAttachmentImage } from "@api/affair.int";
import { Alert, AlertDescription, AlertIcon, Box, Button, Divider, Icon, IconButton, Image, Link, Tooltip, useBoolean, useToast } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { useVVColors } from "components/appComponents";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { NoImage } from "components/NoImage";
import { isLocationAffair, useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvButtonBack, VizvButtonPrimary, VizvCard, VizvCardActionStrip, VizvCardContent, VizvCardHeader2, VizvMainCol } from "components/vizvComponents";
import { useVVNav } from "components/vvNav";
import { TProtectionLevel } from "features/auth/DeepAuth";
import Linkify from 'linkify-react';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { MdChat, MdDelete, MdEdit, MdPinDrop, MdPlayCircleOutline, MdRestore, MdShare, MdVideocam } from "react-icons/md";
import { matchPath, NavLink, Outlet, useLocation, useNavigate, useParams, useSearchParams } from "react-router";
import { AffairImageUpload } from "./AffairImageUpload";
import { VVideoPlayer } from "./AffairVideoUpload";

export interface IAttachmentWKey extends IAttachment {
	attachmentKey: string;
}

export interface IAffairContext {
	affair: IAffairPub;
	isOwnAffair: boolean;
	setAffair: (affair: IAffairPub, newKey: string) => void;

}
export const AffairContext = createContext<IAffairContext>({
	affair: undefined as any,
	isOwnAffair: false,
	setAffair: () => { throw `no affair ctx` },

})

export function AffairLayout(props: { isDetail?: boolean }) {
	const params = useParams() as { affairKey: string, attachmentKey: string };
	return <AffairLayout0 key={params.affairKey || 'empty'} {...props} />
}

function AffairLayout0({ isDetail = false }: { isDetail?: boolean }) {
	const vvNav = useVVNav();
	const loc = useLocation();
	const api = useVVApi();
	const auth = useDeepAuth();
	const store = useVVStore();

	const affairList = useVVStore(state => state.affairList);
	const addLoadedMunicipalities = useVVStore(state => state.addLoadedMunicipalities);
	const addGuardItems = useVVStore(state => state.addGuardItems);
	const addAffairItems = useVVStore(state => state.addAffairItems);


	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const rootPath = vvNav.detailPathName('/affair/:affairKey');
	console.log('detailPathName', rootPath);
	const currPath =
		matchPath(rootPath + '/attachment/:attachmentKey', loc.pathname) ? 'att' :
			matchPath(rootPath + '/edit', loc.pathname) ? 'edit' :
				matchPath(rootPath + '/add', loc.pathname) ? 'add' :
					matchPath(rootPath + '/add/video', loc.pathname) ? 'add' : 'main'

	const params = useParams() as { affairKey: string, attachmentKey: string };
	const [affair, setAffair] = useState<IAffairPub>();
	useEffect(() => {
		setAffair(undefined);
		setError('');
	}, [params.affairKey])
	useEffect(() => {
		const affair = affairList.find(a => a.affairKey === params.affairKey);
		if (affair) {
			setAffair(affair);
		} else {
			(async () => {
				setError('');
				setIsLoading.on();
				try {
					const resp = await api.fetch<IAffariDirectGetApi>({
						url: '/affair/direct/:affairKey', method: 'GET',
						params: { affairKey: params.affairKey }
					});

					if (!resp.affairs.find(a => a.affairKey === params.affairKey))
						throw 'Nem találom az esetet';
					addAffairItems(resp.affairs);
					addGuardItems(resp.guards);
					const distinctParentKeys = Array.from(new Set(resp.affairs.map(aff => aff.parentKey)));
					console.log('DISTINCT::: ', distinctParentKeys);
					addLoadedMunicipalities(distinctParentKeys);


				} catch (ex) {
					setError('' + ex);
				} finally {
					setIsLoading.off();
				}
			})();
		}

	}, [affairList, params.affairKey]);

	const [attachmentsArr, setAttachmentsArr] = useState<IAttachmentWKey[]>([]);
	const toast = useToast();

	const onMapClick = () => {
		if (affair) {
			vvNav.toRoot();
			const loc = store.itemsList.find(item => isLocationAffair(item) && item.dbAffair.affairKey === affair.affairKey);
			store.setSuggestionList(loc ? [loc] : []);
			if (store.isMobile() && store.isTools())
				setTimeout(() => {
					store.setLayoutPush('menu_and_tools');
				}, 300)

		}

	}

	useEffect(() => {
		console.log('------- useEffect .... affair changed -----------');
		const newAttachments = new Array<IAttachmentWKey>();
		if (affair) {
			Object.entries(affair.attachments || {}).forEach(([attachmentKey, attachment]) => {
				newAttachments.push({ ...attachment, attachmentKey });
			});
		}
		setAttachmentsArr(newAttachments);
		//setAttachmentIx(0); //TODO: reset to first
	}, [affair]);

	const onImageUploaded = (newAffair: IAffairPub, newKey: string) => {
		addAffairItems([newAffair]);
		setAffair(newAffair);
		if (newKey) {
			setTimeout(() => {
				vvNav.to(`attachment/${newKey}`)
				//setAttachmentIx(Object.keys(newAffair.attachments || {}).length - 1);
			}, 1000);
		}
	}

	const canModify = affair && auth.userAny && (auth.userAny.isAdmin || auth.userAny.userKey === affair.user.userKey);

	const deleteClick = async () => {
		if (!affair || !window.confirm(`Biztosan törlöd az esetet?`))
			return;
		setIsLoading.on();
		setError('');
		try {
			///debugger;
			const resp = await api.fetch<IAffairDeleteApi>({
				url: '/affair/:affairKey',
				method: 'DELETE',
				params: {
					affairKey: affair.affairKey,
				}
			});

			vvNav.toRoot();
			store.removeAffairItem(affair);
			store.addGroupItems(resp.groups);
			store.resetAfterAction();

			toast({ title: 'Sikeres törlés', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}


	}

	const restoreClick = async () => {
		if (!affair || !window.confirm(`Biztosan visszaállítod az esetet?`))
			return;
		setIsLoading.on();
		setError('');
		try {
			///debugger;
			const resp = await api.fetch<IAffairRestoreApi>({
				url: '/affair/restore/:affairKey',
				method: 'POST',
				params: {
					affairKey: affair.affairKey,
				}
			});

			vvNav.toRoot();
			store.removeAffairItem(affair);
			store.addGroupItems(resp.groups);
			store.resetAfterAction();
			toast({ title: 'Sikeres visszaállítás', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}


	}

	const isDeleted = affair && !!affair.deletedAt;
	const isOwnAffair = (affair && auth.userAny && affair.user.userKey == auth.userAny.userKey) || false;
	const uploadProtLev: TProtectionLevel = isOwnAffair ? 'anyuser' : 'confirmed';


	// ------------------
	const ctx = useMemo(() => ({
		affair: affair!, setAffair: onImageUploaded, isOwnAffair
	}), [affair, onImageUploaded, isOwnAffair]);

	const colors = useVVColors();

	//const adminCtx = useContext(AdminContext);

	return <AffairContext.Provider value={ctx} >
		<VizvMainCol isDetail={isDetail} >

			<VizvCard flex={1} minW='50vw' minH='85vh' onClose={vvNav.toRoot} >
				<DeepErrorBox isLoading={isLoading} error={error || (isDeleted ? 'TÖRÖLT ÜGY' : '')} />
				{affair ? <>

					<Box textAlign='center' p={2} >
						<Box color='InactiveCaptionText' fontSize='sm' as='span' >{affair.user.userName} /
							{formatDateTime(affair.createdAt)}</Box>
					</Box>
					<VizvCardHeader2 kind={affair.affairKind} mt={0}>{affair.title || "(nincs cím)"}</VizvCardHeader2>
					<Box overflowX='auto'>
						<Box display='flex' flexDir='row' alignItems='center' justifyContent='center' gap={2} p={2} width='fit-content'>
							<Tooltip label="Leírás"><NavLink to=''  ><IconButton aria-label="leírás" icon={<MdChat />} fontSize='4xl'
								width='64px' height='64px' alignItems='center' justifyContent='center'
								{...!params.attachmentKey && { borderBottom: `4px solid ${colors.primary}` }}

							/></NavLink></Tooltip>
							<Tooltip label="Mutasd térképen"><IconButton aria-label="leírás" icon={<MdPinDrop />} fontSize='4xl'
								width='64px' height='64px' alignItems='center' justifyContent='center'
								onClick={() => onMapClick()}

							/></Tooltip>
							{attachmentsArr.map(att => <NavLink key={att.attachmentKey} to={`attachment/${att.attachmentKey}`}>
								<Box  {...params.attachmentKey === att.attachmentKey && { borderBottom: `4px solid ${colors.primary}` }}>

									{att.attachKind === 'uploded_image' && <Box width='64px' height='64px'><Image src={process.env.REACT_APP_UPLOADS_DOMAIN + '/' + (att as any).key}
										objectFit='cover' flex={1} overflow='hidden' display='flex' alignItems='center' justifyContent='center'
										width='64px' height='64px'
									/></Box>}
									{att.attachKind !== 'uploded_image' && <Box
										width='64px' height='64px' border='1px solid #8888'
										display='flex' justifyContent='center' alignItems='center'
									><Icon as={MdPlayCircleOutline} fontSize='4xl' /></Box>}
								</Box>
							</NavLink>)}
						</Box>
					</Box>
					<Divider />
					<Outlet />
					{/*adminCtx.isAdmin && <VizvCardActionStrip mt='auto' display='flex' flexDir='row' justifyContent='flex-end'>
						{adminCtx.options.map((action, aix) => 
						<VizvAdminButton key={aix}>{action.title}</VizvAdminButton>)}
					</VizvCardActionStrip>*/}
					{currPath === 'main' && <VizvCardActionStrip mt='auto' display='flex' flexDir={store.isMobile() ? 'column' : 'row'} alignItems='center' p={2} gap={2}>
						{canModify && !isDeleted && <>
							<VizvButtonBack leftIcon={<MdEdit />} onClick={() => vvNav.to('edit')}>Módosítom</VizvButtonBack>
							<VizvButtonBack leftIcon={<MdDelete />} onClick={() => deleteClick()}>Törlöm az esetet</VizvButtonBack>
						</>}

						{canModify && isDeleted && <>
							<VizvButtonBack leftIcon={<MdRestore />} onClick={() => restoreClick()}>Visszaállítom az esetet</VizvButtonBack>
						</>}

						{!isDeleted && <>
							<VizvButtonPrimary ml='auto' onClick={() => vvNav.to('video')} leftIcon={<MdVideocam />} protLev={uploadProtLev} >Videót csatolok</VizvButtonPrimary>
							<AffairImageUpload />
						</>}
					</VizvCardActionStrip>}

				</> : <>Loading...</>}
			</VizvCard>

		</VizvMainCol>
	</AffairContext.Provider >

}


export function AffairDescription() {
	const ctx = useContext(AffairContext);
	const affair = ctx.affair;
	const auth = useDeepAuth();
	const [params] = useSearchParams();
	const isFresh = params.has('fresh')
	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');
	const { shareUrl, ...vvNav } = useVVNav();



	const checkShareLink = async () => {
		try {
			setError('');
			setIsLoading.on();
			const resp = await fetch(shareUrl);
			console.log('-----resp.headers------');
			resp.headers.forEach((val, key) => {
				console.log(val, key);
			})
			console.log('-----/resp.headers------');

		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}

	const linkifyOptions = {
		target: "_blank",
		attributes: {
			className: "xx1"
		}
	};

	return <DeepErrorContainer isLoading={isLoading} error={error} onErrorClose={() => setError('')}>
		<VizvCardContent>
			{isFresh && <Alert status="success">
				<AlertIcon />
				<AlertDescription>
					Köszönjük, hogy bejelentetted az esetet!<br />
					{!auth.userConfirmed && <Box>
						Email-t küldtünk a megadott email címre. Kérlek a levélben megadott linkre kattintva igazold, hogy az email-cím hozzád tartozik.
					</Box>}
					<Box>Ha képed vagy videód is van az esetről itt feltöltheted!</Box>
					{auth.userConfirmed && !auth.userConfirmed.guard && <Box>
						Helyzed el magad a térképen és <Link>legyél te is vízvédő!</Link>
					</Box>}
				</AlertDescription>
			</Alert>}

			<Box color='InactiveCaptionText' fontSize='sm' >Az ügyet bejelentő
				&nbsp;<Link as={NavLink} to={vvNav.detailPath(`/guard/${affair.user.userKey}`)}>{affair.user.userName}</Link>&nbsp;
				írta:</Box>
			<Divider />

			<Linkify options={linkifyOptions}>{affair.description}</Linkify>

			<Divider mb={5} />

			<Box display='flex' flexDir='column' alignItems='center'>
				<Link href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
					target='_blank' bg='#1877F2' color='#fff' p={2} boxShadow='md' borderRadius='sm'
					_hover={{ textDecor: 'none', boxShadow: 'dark-lg' }}


				><Icon as={MdShare} />&nbsp;Megosztom az esetet Facebookon</Link>

				{(auth.userConfirmed?.email == 'tkrizsa@gmail.com') && <Box mt='4em' color='#fff6' textAlign='center'>
					Kísérleti funkció csak admin felhasználóknak:<br />
					<Button as={NavLink} to={`/affair/${ctx.affair.affairKey}/capture-map`} size='sm'>Térkép pillanatkép</Button><br />
					{shareUrl}<br />
					<Button onClick={checkShareLink} size='sm'>Share link check</Button>
				</Box>}
			</Box>

		</VizvCardContent>

	</DeepErrorContainer>

}


export function AffairAttachment() {
	const auth = useDeepAuth();
	const ctx = useContext(AffairContext);
	const affair = ctx.affair;
	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');
	const toast = useToast();
	const api = useVVApi();
	const store = useVVStore();


	const [attachment, setAttachment] = useState<IAttachment>();
	const attNev = attachment?.attachKind === 'uploded_image' ? 'képet' : 'videót';
	const canDelete = attachment && auth.userConfirmed && (auth.userConfirmed.isAdmin || ctx.affair.user.userKey === auth.userConfirmed.userKey || attachment.user.userKey === auth.userConfirmed.userKey)
	const params = useParams() as { affairKey: string, attachmentKey: string };
	useEffect(() => {
		setAttachment(affair.attachments[params.attachmentKey]);
	}, [params.attachmentKey])


	const vvNav = useVVNav();
	const deleteClick = async () => {
		if (!attachment || !window.confirm(`Biztosan törlöd a ${attNev}?`))
			return;
		setIsLoading.on();
		setError('');
		try {
			///debugger;
			const resp = await api.fetch<IAffairAttachmentDeleteApi>({
				url: '/affair/:affairKey/attachment/:attachmentKey',
				method: 'DELETE',
				params: {
					affairKey: ctx.affair.affairKey,
					attachmentKey: params.attachmentKey
				}
			});

			store.addAffairItems([resp.affair]);
			//store.addGroupItems(resp.groups);
			store.resetAfterAction();
			vvNav.toDetail('/affair/' + resp.affair.affairKey);
			toast({ title: 'Sikeres törlés', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}

	return <>

		<VizvCardContent>
			<DeepErrorBox error={error} isLoading={isLoading} />
			{attachment
				? <Box display='flex' alignItems='center' justifyContent='center' flexDir='column'>
					{
						attachment.attachKind === 'uploded_image'
							? <Image src={process.env.REACT_APP_UPLOADS_DOMAIN + '/' + (attachment as IAttachmentImage).key}
								objectFit='scale-down' flex={1} overflow='hidden' display='flex' alignItems='center' justifyContent='center'
								maxH='50vh'
							/>
							: <VVideoPlayer kind={attachment.attachKind} videoId={(attachment as IAttachmentExtVideo).videoId} />
					}

					<Box color='InactiveCaptionText' mt={2} fontSize='sm' as='span' >
						Feltöltötte: {attachment.user.userName} / {formatDateTime(attachment.createdAt)}
					</Box>
				</Box> : <Box display='flex' alignItems='center' justifyContent='center' flexDir='column' gap={3} color='InactiveCaptionText'>
					<NoImage />
					Ismeretlen csatolás...
				</Box>
			}
		</VizvCardContent>
		<VizvCardActionStrip mt='auto'>
			{canDelete && <VizvButtonBack leftIcon={<MdDelete />} onClick={() => deleteClick()}>Törlöm a {attNev}</VizvButtonBack>}
		</VizvCardActionStrip>
	</>


}

/*<Image src={`https://img.youtube.com/vi/${(attachments[attachmentIx] as IAttachmentYoutubeVideo).videoId}/0.jpg`}
	objectFit='scale-down' flex={1} overflow='hidden' display='flex' alignItems='center' justifyContent='center'
	?si=ecQZ63NHxog4-7Da
/>*/
